
export const showPageNumbers = (page, currentPage, totalPages) => {
    return (
        (page === 0 && currentPage < 5) ||
        (page === totalPages - 1 && currentPage > totalPages - 5) ||
        (page > currentPage - 3 && page < currentPage + 2)
    );
};